import { api as dataEnteringApi } from "../api";
import { PurchaseInvoiceDraft } from "./types";
import { AppDispatch } from "../../../shared/redux/types";

interface FetchPurchaseInvoiceDraftParams {
    dispatch: AppDispatch;
    accountId: number | null;
    documentId: number | null;
}

export const purchaseInvoiceDraftApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        getPurchaseInvoiceDraft: build.query<PurchaseInvoiceDraft, { cacheKey: string }>({
            query: () => ({
                url: `api/v1/data_entering/purchase_invoice_draft`,
            }),
            serializeQueryArgs: ({ queryArgs, endpointName }) =>
                `${endpointName}-${queryArgs.cacheKey}`,
        }),
    }),
});

export async function fetchPurchaseInvoiceDraft({
    dispatch,
    accountId,
    documentId,
}: FetchPurchaseInvoiceDraftParams): Promise<PurchaseInvoiceDraft> {
    const cacheKey = `${accountId}-${documentId}`;
    const draftPromise = dispatch(
        purchaseInvoiceDraftApi.endpoints.getPurchaseInvoiceDraft.initiate({ cacheKey }),
    );
    try {
        return await draftPromise.unwrap();
    } finally {
        draftPromise.unsubscribe();
    }
}
